import React from 'react';
import bindAll from 'lodash.bindall';
import {connect} from 'react-redux';

import Modal from '../modal/modal.jsx';
import SoundEditor from '../../containers/sound-editor.jsx';

import PropTypes from 'prop-types';
import {closeSoundEditor} from '../../reducers/modals';

import styles from './sound-editor-modal.css';

class SoundEditorModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
        ]);
    }

    render () {
        return (
            <Modal
                className={styles.modal}
                onRequestClose={this.props.onRequestCloseSoundEditorModal}
            >
                <SoundEditor
                    soundIndex={this.props.soundIndex}
                />
            </Modal>
        );
    }
}

SoundEditorModal.propTypes = {
    onRequestCloseSoundEditorModal: PropTypes.func,
    soundIndex: PropTypes.number
};

const mapDispatchToProps = dispatch => ({
    onRequestCloseSoundEditorModal: () => {
        dispatch(closeSoundEditor());
    }
});

export default connect(null, mapDispatchToProps)(SoundEditorModal);
